import { Component } from '@angular/core';

@Component({
  selector: 'app-teilnahmebedingungen',
  templateUrl: './teilnahmebedingungen.component.html',
  styleUrl: './teilnahmebedingungen.component.scss',
  standalone: false,
})
export class TeilnahmebedingungenComponent {}
